var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.5065C10 19.7828 10.2242 20.0081 10.5002 19.9945C15.7939 19.7339 20.0059 15.3593 20.0059 10.001C20.0059 4.47489 15.526 -0.00488281 10 -0.00488281C4.47391 -0.00488281 -0.00585938 4.47489 -0.00585938 10.001C-0.00585938 14.6288 3.13587 18.5228 7.40281 19.6664C7.70832 19.7484 7.99883 19.5109 7.99883 19.1947V12.0022H6.99824C6.44563 12.0022 5.99766 11.5542 5.99766 11.0016C5.99766 10.4489 6.44564 10.001 6.99824 10.001H7.99883V7.99981C7.99883 6.34198 9.34272 4.99805 11.0006 4.99805H12.0012C12.5538 4.99805 13.0018 5.44603 13.0018 5.99863C13.0018 6.55125 12.5538 6.99922 12.0012 6.99922H11.0006C10.448 6.99922 10 7.4472 10 7.99981V10.001H12.0012C12.5538 10.001 13.0018 10.4489 13.0018 11.0016C13.0018 11.5542 12.5538 12.0022 12.0012 12.0022H10V19.5065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookNew);
export default __webpack_public_path__ + "static/media/facebook-new.17b9568a8476a15a5bdc04fca27c3eec.svg";
export { ForwardRef as ReactComponent };